






























































































































































































































































































































































































































































































































































































































































import { Routes } from "@/router/Routes";
import { Component } from "vue-property-decorator";
import InForceBase from "../base/InForceBase";
import { Route } from "vue-router";
import { inForceStore } from "@/store/modules/InForceStore";
import { InForceCaseData } from "@/models/InForceCaseData";
import { NullableString } from "@/code/Types";
import { BreadCrumb } from "@/store/modules/GlobalStore";
import { Helpers } from "@/code/Helpers";
import { InForceProductGroup } from "@/enums/InForceProductGroup";
import { Pages } from "@/enums/Pages";

@Component
export default class extends InForceBase {
  page = Pages.EXISTING_BUSINESS;
  title = "Existing Policies (Carrier Feeds)";
  search: NullableString = null;
  breadCrumbs = [new BreadCrumb("InForces")];
  dialog = false;

  headers = [
    { text: "Insured Name (Age)", value: "insuredFullName", width: 200 },
    { text: "Policy Number", value: "policyNumber", width: 100 },
    { text: "Product Group", value: "productGroup", width: 100 },
    { text: "Carrier", value: "insuranceCompany" },
    { text: "Product", value: "productName" },
    { text: "Face", value: "faceAmount" },
    {
      text: "Effective",
      value: "effectiveDate",
      sort: (a: NullableString, b: NullableString): number =>
        Helpers.sortDate(a, b),
    },
    {
      text: "Term End / Maturity Date",
      value: "termEndOrMaturityDate",
      sort: (a: NullableString, b: NullableString): number =>
        Helpers.sortDate(a, b),
    },
    { text: "Cash Value / Contract Value", value: "cashOrContractValue" },
    {
      text: "Notifications",
      value: "notificationCount",
      width: 130,
      align: "center",
    },
  ];

  async beforeRouteEnter(
    to: Route,
    from: Route,
    next: () => void
  ): Promise<void> {
    await inForceStore.getAll();
    next();
  }

  get allCases(): InForceCaseData[] {
    return inForceStore.entities;
  }

  async selectPolicy(id: string, productGroup: string): Promise<void> {
    if (productGroup === InForceProductGroup.LIFE) {
      await this.$router.push({
        name: Routes.INFORCE_LIFE_DETAIL,
        params: { id },
      });
    } else if (productGroup === InForceProductGroup.ANNUITY) {
      await this.$router.push({
        name: Routes.INFORCE_ANNUITY_DETAIL,
        params: { id },
      });
    }
  }

  get totalCount(): number {
    return inForceStore.totalCount;
  }

  get totalNotifications(): number {
    return inForceStore.totalNotifications;
  }

  get totalPremium(): number {
    return inForceStore.totalPremium;
  }

  get totalFaceAmount(): number {
    return inForceStore.totalFaceAmount;
  }

  get totalCashValue(): number {
    return inForceStore.totalCashValue;
  }

  get totalDeathClaims(): number {
    return inForceStore.totalDeathClaims;
  }

  get totalLapsed(): number {
    return inForceStore.totalLapsed;
  }

  get totalRiskOfLapsing(): number {
    return inForceStore.totalRiskOfLapsing;
  }

  get totalTermExpired(): number {
    return inForceStore.totalTermExpired;
  }

  get totalTermExpiring(): number {
    return inForceStore.totalTermExpiring;
  }

  get totalConversionExpiring(): number {
    return inForceStore.totalConversionExpiring;
  }

  get totalNearingRetirement(): number {
    return inForceStore.totalNearingRetirement;
  }

  get totalMarketValueAdjustment(): number {
    return inForceStore.totalMarketValueAdjustment;
  }

  get totalSurrenderExpiring(): number {
    return inForceStore.totalSurrenderExpiring;
  }

  get totalSurrenderExpired(): number {
    return inForceStore.totalSurrenderExpired;
  }

  get totalRequiredMinimumDistribution(): number {
    return inForceStore.totalRequiredMinimumDistribution;
  }
  get totalContractAmount(): number {
    return inForceStore.totalContractAmount;
  }
  get totalSurrenderAmount(): number {
    return inForceStore.totalSurrenderAmount;
  }
  get totalLifePolicies(): number {
    return inForceStore.totalLifePolicies;
  }
  get totalAnnuityPolicies(): number {
    return inForceStore.totalAnnuityPolicies;
  }
}
